import { createFileRoute } from '@tanstack/react-router'
import { IncidentDetailRoute } from '@/features/incidents/v2/incident-detail-route'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/$incidentId/'
)({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    tab?: 'overview' | 'forms' | 'tasks' | 'timeline' | 'ndis'
    from?: string
    obligation?: string
  } => ({
    tab: ['overview', 'forms', 'tasks', 'timeline', 'ndis'].includes(
      search.tab as string
    )
      ? (search.tab as never)
      : undefined,
    from: typeof search.from === 'string' ? search.from : undefined,
    obligation:
      typeof search.obligation === 'string' ? search.obligation : undefined,
  }),
  component: IncidentDetailRoute,
})
